/** TODO: Move this component to UI Library */
import React from 'react';
import PropTypes from 'prop-types';

import './optionRow.scss';

const OptionRow = ({ options, defaultValue, selectedValue, onChange, label = 'Options', className = '' }) => {
  const selectedIndex = options.findIndex(
    (option) => (option.value ?? option.levelOfCover ?? option.excess) === selectedValue
  );
  return (
    <div
      className={`optionRow ${className}`}
      role="radiogroup"
      aria-label={label}
    >
      {options.map((option, index) => {
        const isSelected =
          option.value === selectedValue ||
          (option.levelOfCover != null && option.levelOfCover === selectedValue) ||
          (option.excess != null && option.excess === selectedValue);
        const isDefault =
          option.value === defaultValue ||
          (option.levelOfCover != null && option.levelOfCover === defaultValue) ||
          (option.excess != null && option.excess === defaultValue);

        const resolvedValue = option.value ?? option.levelOfCover ?? option.excess;
        return (
          <button
            key={String(resolvedValue)}
            type="button"
            role="radio"
            aria-checked={isSelected}
            tabIndex={isSelected || (selectedIndex === -1 && index === 0) ? 0 : -1}
            className={`button compact ${isSelected ? 'primary' : 'outline'} option ${isSelected ? 'selected' : ''}`}
            onClick={() => {
              if (!isSelected) onChange(resolvedValue);
            }}
          >
            {option.label ||
              (option.levelOfCover != null && `${option.levelOfCover}%`) ||
              (option.excess != null && `$${option.excess}`)}
            {isDefault && (
              <div className="current">
                <span className="arrow" />
                {option.helperText || 'Current renewal'}
              </div>
            )}
          </button>
        );
      })}
    </div>
  );
};

OptionRow.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape({
        label: PropTypes.node.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]).isRequired,
        helperText: PropTypes.string
      }),
      PropTypes.shape({
        levelOfCover: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        helperText: PropTypes.string
      }),
      PropTypes.shape({
        excess: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        helperText: PropTypes.string
      })
    ])
  ).isRequired,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  className: PropTypes.string
};

export default OptionRow;
